import React from 'react'

const collection = [
  { edition: 'collection-JAS-23-2' },
  { edition: 'collection-JAS-23-1' },
  { edition: 'collection-JAS-22-2' },
  { edition: 'collection-JAS-22-1' },
  { edition: 'collection-JAS-21-2' },
  { edition: 'collection-JAS-21-1' },
  { edition: 'collection-JAS-20-3' },
  { edition: 'collection-JAS-20-0' },
  { edition: 'collection-JAS-20-2' },
  { edition: 'collection-JAS-20-1' },
  { edition: 'collection-JAS-15-2' },
  { edition: 'collection-JAS-15-1' },
  { edition: 'collection-JAS-14-2' },
  { edition: 'collection-JAS-14-1' },
  { edition: 'collection-JAS-11-1' },
  { edition: 'collection-JAS-10-2' },
  { edition: 'collection-JAS-10-1' },
  { edition: 'collection-JAS-09-1' }
]

export const SlideShow = () => (
  <div
    className='uk-position-relative uk-visible-toggle'
    tabIndex={-1}
    data-autoplay
    data-autoplay-interval='4000'
    data-uk-slideshow='min-height: 450; max-height: 450; animation: slide'>
    <ul className='uk-slideshow-items'>
      {collection.map(item => (
        <li key={item.edition} className='hero-slideshow-item'>
          <img
            className='hero-slideshow-image'
            src={`collections/${item.edition}.jpg`}
            alt='hero-cover'
          />
        </li>
      ))}
    </ul>
    <span
      className='uk-position-center-left uk-position-small uk-hidden-hover'
      data-uk-slidenav-previous
      data-uk-slideshow-item='previous'></span>
    <span
      className='uk-position-center-right uk-position-small uk-hidden-hover'
      data-uk-slidenav-next
      data-uk-slideshow-item='next'></span>
  </div>
)
